export const WORDOPOLIS_STAGE_SIZE = 800;
export const WORDOPOLIS_CELL_STROKE = 2;

export const COLOR_NEUTRALS_WHITE = "#FCFCFC";
export const COLOR_NEUTRALS_300 = "#E8E8E8";
export const COLOR_NEUTRALS_FONT_SECONDARY = "#4E4F4B";

export const COLOR_BRAND_ORANGE_BASE = "#F27124";

export const COLOR_BRAND_TURQUISE_BASE = "#00DCD9";
export const COLOR_BRAND_TURQUISE_900 = "#007574";

export const COLOR_BRAND_ROSE_700 = "#FF1A38";

export const COLOR_BRAND_BLUE_900 = "#1FA7FF";
